module.exports = __webpack_public_path__ + "197e77f511c9a19a1b38350ee5399c0d.jpg";